var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      ref: "modal",
      attrs: { placement: "left", width: "250", trigger: "click" },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        { staticStyle: { "text-align": "center", "margin-bottom": "20px" } },
        [
          _vm._v("\n    Are you sure to cancel request "),
          _c("br"),
          _vm._v(" "),
          _c("b", [_vm._v(_vm._s(_vm.request.uuid))]),
          _vm._v("?\n    "),
          _c(
            "div",
            { staticStyle: { margin: "10px 0px" } },
            [
              _c("el-input", {
                attrs: { type: "textarea", placeholder: "Add comment" },
                model: {
                  value: _vm.comment,
                  callback: function ($$v) {
                    _vm.comment = $$v
                  },
                  expression: "comment",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "justify-content": "center", display: "flex" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", disabled: !_vm.comment },
              on: {
                click: function ($event) {
                  return _vm.cancelRequest()
                },
              },
            },
            [_vm._v("\n      Confirm\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          attrs: {
            slot: "reference",
            size: "small",
            type: "danger",
            disabled: _vm.visible,
          },
          slot: "reference",
        },
        [_vm._v("\n    Cancel\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }